import React from 'react';
import { getPropertyManagerDisplayName } from '../../utils/propertyManagers';

function TeamNamePill({ team }) {
  const teamColor = team?.color || '#6B7280';
  return (
    <span
      className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium"
      style={{
        backgroundColor: `${teamColor}1F`,
        borderColor: teamColor,
        color: teamColor,
      }}
    >
      {team.name}
    </span>
  );
}

export default function PropertyManagementDisplay({
  team,
  managers = [],
  handleCallManager,
  emptyLabel = 'No property manager assigned',
  showCallButtons = true,
}) {
  const hasTeam = Boolean(team?.name);
  const hasManagers = managers.length > 0;

  if (!hasTeam && !hasManagers) {
    return (
      <p className="text-sm text-gray-500 italic">
        {emptyLabel}
      </p>
    );
  }

  return (
    <div className="space-y-3">
      {hasTeam && <TeamNamePill team={team} />}
      {managers.map((manager) => {
        const displayName = getPropertyManagerDisplayName(manager);
        return (
          <div key={manager.id || displayName}>
            <p className="text-sm text-gray-700">
              {displayName}
              {manager.phoneNumber && (
                <span className="ml-2 text-gray-500">{manager.phoneNumber}</span>
              )}
            </p>
            {showCallButtons && manager.phoneNumber && (
              <div className="mt-1.5">
                <a
                  href={`tel:${manager.phoneNumber}`}
                  onClick={() => handleCallManager?.(manager.phoneNumber)}
                  className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-blue-700 bg-blue-50 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  aria-label={`Call property manager ${displayName}`}
                >
                  <svg className="mr-2 h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                  </svg>
                  Call Manager
                </a>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
